import * as React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCircleXmark } from '@fortawesome/free-solid-svg-icons'

import * as Style from './style.css'

export interface IProps {
  texts: string[]
  clickhandler?: (() => Promise<void>) | (() => void)
}

export const IndicatorAlerts = ({
  texts,
  clickhandler,
}: IProps): JSX.Element => (
  <div
    className={Style.IndicatorAlert}
    onClick={() => clickhandler && void clickhandler()}
  >
    <FontAwesomeIcon
      icon={faCircleXmark}
      className={Style.IndicatorAlertIcon}
    />
    以下の項目を確認ください
    <ul className={Style.IndicatorAlertBody}>
      {texts.map((text) => (
        <li className={Style.IndicatorAlertItem} key={`indicator-${text}`}>
          {text}
        </li>
      ))}
    </ul>
  </div>
)
